import * as stylex from "@stylexjs/stylex";
import ReactDOM from "react-dom";
const PORTAL_ROOT_ID = "portal-root";
/**
 * Used through React Portal to display modal dialogs, tooltips, etc.
 */ export function PortalRoot() {
    return <div id={PORTAL_ROOT_ID} className="x10l6tqk x13vifvy xu96u03"></div>;
}
/**
 * Use this to render a component outside of the normal application's DOM tree
 * in the "portal root". This element is defined in `pages/_document.tsx` next
 * to the application's root DOM node.
 *
 * See https://reactjs.org/docs/portals.html
 */ export function Portal({ children }) {
    const modalRoot = document.getElementById(PORTAL_ROOT_ID);
    if (!modalRoot) {
        console.error(`Portal root not found at id #${PORTAL_ROOT_ID}, could not create portal.`);
        return null;
    }
    return ReactDOM.createPortal(children, modalRoot);
}
